import { getIdFromText } from 'utils/formatters';

const getHeadingElements = (contentWrapper: string) => {
  const wrapperElement = document.getElementById(contentWrapper);
  const headings = wrapperElement?.querySelectorAll('h2');
  return headings;
};

export const addIdsToHeadings = (contentWrapper: string) => {
  const headings = getHeadingElements(contentWrapper);
  if (!headings) return;

  Array.from(headings).forEach((heading: HTMLHeadingElement, index: number) => {
    if (heading.id) {
      return;
    }
    heading.id = getIdFromText(heading.textContent || `heading-${index}`);
    // Add offset class to account for fixed header/navigation
    heading.classList.add('scroll-mt-[var(--height-nav)]');
  });
};

export const getHeadingDetails = (contentWrapper: string) => {
  const headings = getHeadingElements(contentWrapper);
  if (!headings) return [];

  return Array.from(headings).map((heading: HTMLHeadingElement) => ({
    label: heading.textContent,
    anchor: heading.id,
  }));
};
